/* eslint-disable */
import { FC } from 'react';
import styles from '../../styles/components/controlVariations/ConfirmDownloadModal.module.css';
import ErrorPopup from '../../assets/icons/PopupErrorIcon.png';

interface Props {
	title: string;
	onCancel: () => void;
}

const ErrorPopupModal: FC<Props> = ({ title, onCancel }) => {
	return (
		<div className={styles.modal}>
			<div className={styles.iconWrapper}>
				<img src={ErrorPopup} alt="ERROR" />
			</div>

			<h2 className={styles.title}>{title}</h2>

			<div className={styles.actions}>
				<button className={styles.errorButton} onClick={onCancel}>
					Close
				</button>
			</div>
		</div>
	);
};

export default ErrorPopupModal;
